import {Component, OnDestroy, OnInit}       from '@angular/core';
import {NgbModal, NgbModalOptions}          from "@ng-bootstrap/ng-bootstrap";
import {HttpErrorResponse}                  from "@angular/common/http";
import {Router}                             from "@angular/router";

import {AngularQuery}                       from "../../../services/query/angularquery";
import {environment}                        from "../../../../environments/environment";
import {FeedService}                        from "../../../services/feed/feed.service";
import {Message}                            from "../../../services/message/message";
import {MessageEntry}                       from "../../../services/message/message-entry";
import {MessageService}                     from "../../../services/message/message.service";
import {RssmanagerEditComponent}            from "./edit/rssmanager-edit.component";
import {RssmanagerItem}                     from "../../../services/feed/rssmanageritem";
import {Vendor}                             from "../../../services/vendor/vendor";
import {VendorService}                      from "../../../services/vendor/vendor.service";

import {Observable}                         from "rxjs/Observable";
import {Subscription}                       from "rxjs/Subscription";
import {isNullOrUndefined}                  from "util";


@Component({
	selector: 'app-rssmanager',
	templateUrl: './rssmanager.component.html',
	styleUrls: ['./rssmanager.component.css']
})


/**
 * The object that displays the Rssmanager screen and handles interaction with it.
 */
export class RssmanagerComponent implements OnInit, OnDestroy {

	allCategories:string[] = [

		'breakingnews', 'depthchart', 'draft', 'expdraft', 'fantasy', 'free',
		'inactive', 'injury', 'pitching', 'transaction'

	];
	codes:string[] = ['NFL', 'MLB', 'NBA', 'NHL', 'NSC'];
	displays:string[] = ['Stats Display', 'Standard KFFL', 'Player IDs'];
	feedUrlStart:string = 'https://d26xb3dy7xx2vt.cloudfront.net/api/fantasy/feed/';
	items:RssmanagerItem[] = [];
	itemsSubscription:Subscription;
	message: Message;
	order_field:string = 'title';
	outputs:string[] = ['JSON', 'XML'];
	sort_order:string = 'asc';
	subscription: Subscription;
	vendors:Vendor[] = [];
	vendorSubscription:Subscription;


	/**
	 * Initialize the object.
	 *
	 * @param feedService      Retrieves the list of feeds.
	 * @param messageService   Handles communication with the message bar.
	 * @param modalService     The service that allows the edit modal to appear.
	 * @param router           The Router singleton used for navigation.
	 * @param vendorService    Retrieve vendor information.
	 */
	constructor(

		private feedService:FeedService,
		private messageService: MessageService,
		private modalService: NgbModal,
		private router: Router,
	    private vendorService: VendorService,

	) {}


	/**
	 * Set up messaging and load the feeds list.
	 */
	ngOnInit() {

		// Set up communications with the MessageService.
		this.subscription = this.messageService.subject.subscribe( message => { this.message = message; } );

		// Get the vendor list.
		this.vendorSubscription = this.vendorService.getVendors().subscribe(

			(response) => {

				// Get the list of vendors from the database.
				this.vendors = response;
				// Add KFFL as a 'vendor', so it can export its own IDs.
				let vendor:Vendor = new Vendor();
				vendor.id = -1;
				vendor.json_name = 'kffl';
				vendor.name = 'KFFL.com';
				vendor.data_name = 'id';
				this.vendors.push(vendor);

			},
			() => {

				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Failed to retrieve vendor information',
					level: 4

				}));

			}

		);

		// Get the initial display of the items.
		this.retrieveItems();

	}


	/**
	 * Close the subscriptions to avoid a memory leak.
	 */
	ngOnDestroy() {

		if (this.itemsSubscription) {
			this.itemsSubscription.unsubscribe();
		}

		if (this.subscription) {
			this.subscription.unsubscribe();
		}

		if (this.vendorSubscription) {
			this.vendorSubscription.unsubscribe();
		}

	}


	/**
	 * Create a new RssmanagerItem object with default entries and display it in the edit window.
	 */
	createItem():void {

		let item:RssmanagerItem = new RssmanagerItem();
		item.id = -1;
		item.code = 'NFL';
		item.categories = '';
		item.url = '';
		item.is_active = 'Yes';
		item.limit = 10;
		item.output = 'XML';
		item.display = 'Standard KFFL';
		item.team_id = 'id';
		item.player_id = 'id';
		this.editItem(item);

	}


	/**
	 * Delete the specified item.
	 *
	 * @param id  The ID of the item to delete.
	 */
	deleteItem(id:number): void {

		// Give them the option to cancel.
		if (! window.confirm('Are you sure you want to delete RSS feed #' + String(id) + '?')) {
			return;
		}

		this.messageService.sendMessageEntry(new MessageEntry({

			message: 'Deleting item #' + id.toString() + '...',
			level: 1

		}));

		// Cancel the existing subscription.
		if (this.itemsSubscription) {
			this.itemsSubscription.unsubscribe();
		}

		// Delete the item and report back on success or failure.
		this.itemsSubscription = this.feedService.deleteItem(id).subscribe(

			() => {

				// Remove the deleted item from the list and notify.
				this.items = this.items.filter(obj => obj.id !== id);
				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Deletion of item #' + id.toString() + ' succeeded',
					level: 1

				}));

			},

			() => {

				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Item #' + id.toString() + ' failed to delete',
					level: 4

				}));

			}

		);

	}


	/**
	 * Find the existing RssmanagerItem by its ID and pass that
	 * to the editItem() method.
	 *
	 * @param id  The ID of the object to be edited.
	 */
	editExistingItem(id:number):void {

		// Find the existing item and call it up in the edit window.
		let item:RssmanagerItem = this.items.find(obj => obj.id === id);
		this.editItem(item);

	}


	/**
	 * Edit the specified item in a modal window.
	 *
	 * @param item   The RssmanagerItem to edit.
	 */
	editItem(item:RssmanagerItem): void {

		let opts:NgbModalOptions = {

			'size': "lg"

		};

		const modalRef = this.modalService.open(RssmanagerEditComponent, opts);
		modalRef.componentInstance.allCategories = this.allCategories;
		modalRef.componentInstance.codes = this.codes;
		modalRef.componentInstance.displays = this.displays;
		modalRef.componentInstance.outputs = this.outputs;
		modalRef.componentInstance.feedUrlStart = this.feedUrlStart;
		modalRef.componentInstance.vendors = this.vendors;


		if (-1 === item.id) {

			modalRef.componentInstance.windowTitle = 'Creating a new entry';
			modalRef.componentInstance.item = item;

		} else {

			modalRef.componentInstance.windowTitle = 'Editing \'' + item.title + '\' (#' + item.id + ')';
			modalRef.componentInstance.item = new RssmanagerItem(item);  // Must work on a clone of the item.

		}

		// When the user clicks the Save button, this saves the changes.
		modalRef.result.then((result) => {

			// Hitting the 'Cancel' button returns a null result.
			if (! isNullOrUndefined(result)) {

				result = new RssmanagerItem(result);

				// Hitting the 'Save' button should return a proper item.
				if (! (result instanceof RssmanagerItem)) {

					// Notify the user something went wrong.
					this.messageService.sendMessageEntry(new MessageEntry({

						message: 'Save failed because post was not valid',
						level: 4

					}));

					return;

				}

				// Vet the URL before saving.
				let pattern = new RegExp('^[-0-9a-zA-Z]*$');

				if (pattern.test(result.url)) {

					this.postItem(result);

				} else {

					// Notify the user something went wrong.
					this.messageService.sendMessageEntry(new MessageEntry({

						message: 'Save failed because of invalid URL',
						level: 4

					}));

				}

			}

		});

	}


	/**
	 * POST the supplied RssmanagerItem to the database.
	 *
	 * @param item  The object to post.
	 */
	postItem(item:RssmanagerItem):void {

		// Notify the user.
		this.messageService.sendMessageEntry(new MessageEntry({

			message: 'Saving \'' + item.title + '\' ...',
			level: 1

		}));

		let query: AngularQuery = new AngularQuery();
		query.useCacheBuster(false);
		query.useParams(false);

		// For post of new item vs. existing item.
		if (-1 === item.id) {

			query.setEndpoint(AngularQuery.ENDPOINT_RSSMANAGER, 'new');

		} else {

			query.setEndpoint(AngularQuery.ENDPOINT_RSSMANAGER, item.id.toString());

		}

		let url:string = query.getUrl();

		// Unsubscribe.
		if (this.itemsSubscription) {
			this.itemsSubscription.unsubscribe();
		}

		// Save the item to the database and deal with what happens.
		this.itemsSubscription = this.feedService.postItem(url, JSON.stringify(item)).subscribe(

			(response) => {

				let postedItem:RssmanagerItem = response;
				let existingItem:RssmanagerItem = this.items.find(obj => obj.id === postedItem.id);

				// If the item isn't found, then it must be new.  Make it the first item in the list.
				if (isNullOrUndefined(existingItem)) {

					this.items.unshift(postedItem);

				} else {

					let index:number = this.items.indexOf(existingItem);
					this.items[index] = postedItem;

				}

				// Notify the user.
				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Saved \'' + postedItem.title + '\' (#' + postedItem.id + ')',
					level: 1

				}));

			},

			() => {

				// Notify the user that something went wrong.
				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Unable to save the item',
					level: 4

				}));

			}

		);

	}


	/**
	 * Retrieve all the items.
	 */
	retrieveItems(): void {

		// Unsubscribe.
		if (this.itemsSubscription) {
			this.itemsSubscription.unsubscribe();
		}

		this.itemsSubscription = this.feedService.getRssmanagerItems(this.order_field, this.sort_order).subscribe(

			(response) => {

				this.items = response;
				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Ready',
					level: 1

				}));

			},

			(error) => {

				// Send an error message for anything but a 404.
				// 404s mean "no records found" in ReST API; that's not an error most of the time.
				if (error instanceof HttpErrorResponse) {

					if (404 !== error.status) {

						this.messageService.sendMessageEntry(new MessageEntry({

							message: 'Couldn\'t retrieve feeds list',
							level: 4

						}));

					}

				}

				return Observable.of(<Array<RssmanagerItem>>([]));

			}

		);

	}


	/**
	 * Set up the retrieval of all of the items and
	 * then call retrieveItems().
	 *
	 * @param order_field  The field to order the results by.
	 * @param sort_order   Ascending or descending sort.
	 */
	setRetrieval(order_field:string, sort_order:string): void {

		this.messageService.sendMessageEntry(new MessageEntry({

			message: 'Loading...',
			level: 1

		}));

		this.order_field = order_field;
		this.sort_order = sort_order;
		this.retrieveItems();

	}


	/**
	 * Reverse the published status of the specified item.
	 *
	 * @param id  The ID of the item to publish or unpublish.
	 */
	togglePublishItem(id:number): void {

		// Find the existing item to see whether it is published or not.
		let replacement:RssmanagerItem = this.items.find(obj => obj.id === id);
		let action:string = ('Yes' === replacement.is_active) ? 'Unpublishing' : 'Publishing';

		this.messageService.sendMessageEntry(new MessageEntry({

			message: action + ' item #' + id.toString() + '...',
			level: 1

		}));

		replacement.is_active = ('Yes' === replacement.is_active) ? 'No' : 'Yes';

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_RSSMANAGER, id.toString());
		query.useCacheBuster(false);
		query.useParams(false);

		let url:string = query.getUrl();

		// Cancel the existing subscription.
		if (this.itemsSubscription) {
			this.itemsSubscription.unsubscribe();
		}

		// Delete the item and report back on success or failure.
		this.itemsSubscription = this.feedService.putItem(url, JSON.stringify(replacement)).subscribe(

			(response) => {

				// Replace the existing item with the modified item and notify.
				let index:number = this.items.indexOf(replacement);
				this.items[index] = response;
				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Modification of item #' + id.toString() + ' succeeded',
					level: 1

				}));

			},

			() => {

				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Modification of item #' + id.toString() + ' failed',
					level: 4

				}));

			}

		);

	}


	/**
	 * Open the provided URL in a new window.
	 *
	 * @param url  The URL to view.
	 */
	viewFeed(url:string): void {

		window.open(url, "_blank");

	}


	/**
	 * Switch back to the story list.
	 *
	 */
	viewStoryList(): void {

		this.router.navigate(['/articles/list']);

	}

}



// WEBPACK FOOTER //
// ./src/app/articles/feed/rssmanager/rssmanager.component.ts